
export default {
  getRuleInfoData: '/v3/serveScore/new/starStandard'
}
